import { useEffect, useRef, useState } from 'react'

const LevelTransition = ({ levelKey, direction, children }) => {
  const prevKey = useRef(levelKey)
  const [animClass, setAnimClass] = useState('')

  useEffect(() => {
    if (prevKey.current === levelKey) return
    prevKey.current = levelKey
    const cls = direction === 'forward' ? 'level-enter-up' : 'level-enter-down'
    setAnimClass(cls)
    const t = setTimeout(() => setAnimClass(''), 280)
    return () => clearTimeout(t)
  }, [levelKey, direction])

  return <div className={`level-transition ${animClass}`}>{children}</div>
}

export default LevelTransition
